import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CropperPosition, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { EToastType, HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from 'src/environments/environment';
import { AttractScreenImageVO } from '../../services/attract-screen.model';
import { AttractScreenService } from '../../services/attract-screen.service';

@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss']
})
export class ImageEditorComponent implements OnInit {
  private backgroundColor = 'rgb(0,0,0)';
  private croppedImage: string | any;
  private loadedImage: LoadedImage;
  private isSmallImage = false;
  private seImageUrl: string;
  private siImageUrl: string;
  private consoleMinHeight: number;
  private consoleMinWidth: number;
  private aspectRatio: number;
  private imageBase64: string;
  private lfCropper = new lfCropperPosition();

  @Input() resolutionWidth: number;  
  @Input() resolutionHeight: number;
  @Input() imageDetails: AttractScreenImageVO;
  @Output() imageDetailsUpdated = new EventEmitter();
  constructor(private attractScreenServ: AttractScreenService,
    private toast: HaloToastService,
    private commonUtil: CommonUtil,
    private amplitudeAnalytics: AmplitudeAnalyticsService) { }

  ngOnInit(): void {
    this.aspectRatio = this.resolutionWidth / this.resolutionHeight;
    if(this.imageDetails.redRGB != undefined && this.imageDetails.greenRGB != undefined && this.imageDetails.blueRGB != undefined) {
      this.backgroundColor = `rgb(${this.imageDetails.redRGB},${this.imageDetails.greenRGB},${this.imageDetails.blueRGB})`;
    }
    this.getConsoleRequirement();
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.imageDetails.attractScreenSECroppingParam = {
      X: Math.round(event.imagePosition.x1),
      Y: Math.round(event.imagePosition.y1),
      H: Math.round(event.imagePosition.y2 - event.imagePosition.y1),
      W: Math.round(event.imagePosition.x2 - event.imagePosition.x1),
      uiX: Math.round(event.cropperPosition.x1),
      uiY: Math.round(event.cropperPosition.y1),
      uiH: Math.round(event.cropperPosition.y2 - event.cropperPosition.y1),
      uiW: Math.round(event.cropperPosition.x2 - event.cropperPosition.x1)
    }
    if(this.imageDetails.imageFile) {        // add image 
      this.imageDetails.attractScreenSICroppingParam = this.imageDetails.attractScreenSECroppingParam;
    }
    this.imageDetailsUpdated.emit(this.imageDetails);
  }

  imageLoaded(image: LoadedImage) {
    this.loadedImage = image;
    this.imageBase64 = image.original.base64;
    this.isSmallImage = image?.original.size.height < this.consoleMinHeight || image?.original.size.width < this.consoleMinWidth;
    this.imageDetails.enableBackgroundColor = this.isSmallImage;
    if(this.isSmallImage) {
      this.croppedImage = image.original.base64;
      this.imageDetails.attractScreenSECroppingParam = {
        X: 0,
        Y: 0,
        H: image.original.size.height,
        W: image.original.size.width,
        uiX: 0,
        uiY: 0,
        uiH: image.original.size.height,
        uiW: image.original.size.width
      }
      if(this.imageDetails.imageFile) {        // add image 
        this.imageDetails.attractScreenSICroppingParam = this.imageDetails.attractScreenSECroppingParam;
      }
    }
  }

  cropperReady(dimension: any) {
    if(this.imageDetails.croppingParam && this.imageDetails.imageType === 'D') {   // edit
      let x1 = Number(this.imageDetails.croppingParam.uiX);
      let y1 = Number(this.imageDetails.croppingParam.uiY);
      let w = Number(this.imageDetails.croppingParam.uiW);
      let h = Number(this.imageDetails.croppingParam.uiH);
      this.lfCropper = new lfCropperPosition();
      this.lfCropper.x1 = x1;      
      this.lfCropper.y1 = y1;
      this.lfCropper.x2 = x1 + w;      
      this.lfCropper.y2 = y1 + h;
    }
  }

  loadImageFailed() {
    //this.amplitudeAnalytics.logEvent('Failed to load image.');
    this.toast.creatToast(this.commonUtil.translateText('ERROR.LOADING.IMAGE'), EToastType.ERROR);
  }

  onColorChange(color: string) {
    let rgbColor = color.substring((color.indexOf("(")+1), color.indexOf(")"))?.split(",");
    if(rgbColor?.length > 1) {
      this.imageDetails.redRGB = Number(rgbColor[0]);
      this.imageDetails.greenRGB = Number(rgbColor[1]);      
      this.imageDetails.blueRGB = Number(rgbColor[2]);
    }
    this.imageDetailsUpdated.emit(this.imageDetails);
  }

  private getConsoleRequirement() {
    this.consoleMinWidth = 885;    
    this.consoleMinHeight = 500;
    this.seImageUrl = this.attractScreenServ.getConsoleImage(this.imageDetails.consoleType??'');
    switch(this.imageDetails.consoleType) {
      case 'discover':
        this.seImageUrl = this.attractScreenServ.getConsoleImage('discover_se');
        this.siImageUrl = this.attractScreenServ.getConsoleImage('discover_si');
        break;
      case 'aquaman':
        this.consoleMinHeight = 636;
        break;
      case 'superman':
        this.consoleMinHeight = 654;
        break;
      case 't3':
        this.consoleMinHeight = 832;
        break;
    }
  }
}

class lfCropperPosition implements CropperPosition {
  x1: number;
  y1: number;
  x2: number;
  y2: number; 
}